import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { VesselCrewOvertimeEditPage } from './vessel-crew-overtime-edit';
import { SharedModule } from '../../../shared/shared.module';
import { FoundationModule } from '../../../../_foundation/foundation.module';
import { PipesModule } from '../../../../pipes/pipes.module';
import { DirectivesModule } from '../../../../directives/directives.module';

@NgModule({
  declarations: [
    VesselCrewOvertimeEditPage,
  ],
  imports: [
    IonicPageModule.forChild(VesselCrewOvertimeEditPage),
    SharedModule,
    FoundationModule,
    PipesModule,
    DirectivesModule,
  ],
})
export class VesselCrewOvertimeEditModule {
}



// WEBPACK FOOTER //
// ./src/pages/DPR Pages/vessel-crew/vessel-crew-overtime-edit/vessel-crew-overtime-edit.module.ts